// useAuthStore.ts — cookie session 模式（不再持久化 token）
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import api from '~/api';

export const useAuthStore = defineStore('authStore', () => {
    // token 字段保留以兼容旧代码引用，但实际不再使用；isLogin 由 comm.userInfo 推导
    const token = ref('');
    const comm = useCommStore();
    // userInfo 由 comm store 持久化，刷新后 isLogin 立即可用，避免 auth 中间件在 bootstrap 完成前误跳登录页
    const isLogin = computed(() => !!comm.userInfo);

    async function login(_tk?: string) {
        // cookie 已由 server 写入，拉一次资料即可标记登录。
        await comm.setUserInfo();
    }

    async function logout(redirectTo = '/') {
        const router = useRouter()
        try {
            await api.logout();
        } catch {/* ignore */}
        token.value = '';
        comm.clearUserInfo();
        router.push(redirectTo)
    }

    /** App 启动时调一次：cookie 在则自动登录 */
    async function bootstrap() {
        await comm.setUserInfo();
    }

    return {
        login,
        logout,
        bootstrap,
        token,
        isLogin
    };
});
